export enum SubscriptionNotificationType {
  FIRST_PAYMENT_NOT_COMPLETED = 'FIRST_PAYMENT_NOT_COMPLETED',
  FIRST_PAYMENT_NOT_COMPLETED_POPUP = 'FIRST_PAYMENT_NOT_COMPLETED_POPUP',
  RENEW_FAILS_DAY_1 = 'RENEW_FAILS_DAY_1',
  RENEW_FAILS_DAY_15 = 'RENEW_FAILS_DAY_15',
  RENEW_FAILS_DAY_30 = 'RENEW_FAILS_DAY_30',
  RENEW_FAILS_DAY_30_POPUP = 'RENEW_FAILS_DAY_30_POPUP',
}
